import settings from '../../../config/settings';
import _ from 'lodash';

export default class PageUtils {
  static getTitle() {
    return _.get(settings, 'website.title');
  }
}



// WEBPACK FOOTER //
// ./shared/utils/PageUtils.js